{
  "platform": {
    "title": "платформа",
    "checking": "проверка",
    "failed": "сбой",
    "partialShort": "частично",
    "healthy": "Платформа здорова",
    "degraded": "Платформа работает с ограничениями",
    "partial": "Работает не всё: {{list}}",
    "noApi": "Нет связи с api",
    "unavailable": "Недоступно: {{list}}",
    "allUp": "Все зависимости доступны"
  }
}
